export const GET_PERMISSION = 'PERMISSION/get_permission';
export const GET_SINGLE_SETTING = 'PERMISSION/get_single_setting';
export const UPDATE_PERMISSION = 'PERMISSION/update_permission';
export const CREATE_PERMISSION = 'PERMISSION/create_permission';
export const REMOVE_PERMISSION = 'PERMISSION/remove_permission';

export const GET_LIST_PERMISSION = 'PERMISSION/get_list_permission';

export const FORM_DATA = {
  name: ''
}

